import * as React from 'react';
import Modal from "react-responsive-modal";
import Input from "../../../common/Input/Input";
import InputUtils, {Type} from "../../../../InputUtils";
import {useEffect, useState} from "react";
import './joinTenantModal.css'
import {joinOrganizationRequest} from "../../../../actions/boCoreActions";

interface Props {
    showModal: boolean,
    tenants: any[],

    onCloseModal(): void
}

const JoinTenantModal = (props: Props) => {
    const [form, setForm] = useState(JSON.parse(JSON.stringify(defaultForm)))

    useEffect(() => {
        if (props.showModal) {
            const formCopy = JSON.parse(JSON.stringify(form));
            formCopy.tenants.options = props.tenants;
            setForm(formCopy);
        }
    }, [props.showModal])

    const onChange = (event, id, inputType) => {
        const formCopy = JSON.parse(JSON.stringify(form));
        let eventValue;
        if (inputType === 'select') {
            eventValue = event ? event : [];
        } else {
            eventValue = event.target.value;
        }

        setForm({
            ...formCopy,
            [id]: {
                ...formCopy[id],
                value: eventValue,
                valid: true
            }
        });
    }

    const close = () => {
        setForm(InputUtils.resetForm(form));
        props.onCloseModal();
    }

    const checkFormValidity = (): boolean => {
        const formCopy = JSON.parse(JSON.stringify(form));
        let formIsValid = true;
        if (!formCopy.tenants.value || Object.keys(formCopy.tenants.value).length < 1) {
            formCopy.tenants.valid = false;
            formIsValid = false;
        }
        setForm(formCopy);
        return formIsValid;
    }

    const joinOrganization = () => {
        if (checkFormValidity()) {
            joinOrganizationRequest(form.tenants.value.id)
                .then(() => {
                    close();
                })
        }
    }

    return (
        <Modal
            open={props.showModal}
            styles={{
                overlay: {zIndex: 10000},
                closeButton: {display: "none"},
                modal: {
                    width: 600,
                    padding: 0,
                    maxWidth: 600,
                }
            }}
            closeOnEsc={true}
            onClose={close}
            center
            focusTrapped={true}
            closeOnOverlayClick={false}
        >
            <div style={{width: '100%', height: '85%', backgroundColor: "#2B2B2B"}}>
                <div className="row" style={{height: '100%'}}>
                    <div id={'create-role-container'} className='col-lg-12 compare-changes'>
                        <header className={'join-tenant-modal-header'}>
                            <h2>Join Organization</h2>
                        </header>
                        <div className={'join-tenant-modal-container'}>
                            <div className={'join-tenant-form'}>
                                <Input id={'tenant'}
                                       value={form.tenants.value}
                                       required={true}
                                       elementType={Type.SELECT}
                                       changed={(event) => onChange(event, 'tenants', 'select')}
                                       classNameProp={'input-full-width margin-input-for-label'}
                                       valid={form.tenants.valid}
                                       errorMsg={form.tenants.errorMsg}
                                       selectInitialPosition={true}
                                       label={'Select Organization'}
                                       elementConfig={{
                                           placeholder: 'Organizations',
                                           tabIndex: 1,
                                           options: form.tenants.options,
                                       }}
                                />
                            </div>
                        </div>
                        <footer style={{
                            background: "#2D3436",
                            borderTop: "2px solid #f5f5f5a3",
                            height: 49,
                            width: "100%",
                            paddingRight: 5,
                            paddingTop: 3,
                        }}>
                            <button
                                onClick={joinOrganization}
                                className={"btn"}
                                id={'btn-save'}
                                style={{float: "right", marginTop: 3, marginLeft: 4}}>
                                <i className="fas fa-paper-plane"> Sent Request</i>
                            </button>
                            <button
                                onClick={close}
                                className={"btn"}
                                style={{float: "right", marginTop: 3, marginRight: 2}}>
                                <i className="fas fa-times"> Close</i>
                            </button>
                        </footer>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

const defaultForm = {
    tenants: {
        value: '',
        valid: true,
        errorMsg: 'Please select organization',
        options: [],
    },
}

export default JoinTenantModal;



// WEBPACK FOOTER //
// ./app/components/bo-core/modals/JoinTenantModal/JoinTenantModal.tsx